<mat-drawer-container class="example-container" autosize>
    <div class="sidenav-btn">
        <mat-icon (click)="drawer.toggle()" (click)="drawerSymbol()" *ngIf="showFiller == false">
            toggle_off
        </mat-icon>
        <mat-icon (click)="drawer.toggle()" (click)="drawerSymbol()" *ngIf="showFiller == true">
            toggle_on
        </mat-icon>
    </div>

    <mat-drawer #drawer class="example-sidenav" mode="side" opened>
      
     <div class="container">
        <div class="row ml-1 mr-1 mt-1">
          <h4>Select Filter</h4>
        </div>

        <div class="row ml-1 mr-1 mt-1">
          <mat-form-field>
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="date1" (dateInput)="addEvent('input', $event,'date1_start')">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="row ml-1 mr-1 mt-1">
          <mat-form-field>
            <mat-label>End Date</mat-label>
            <input matInput [min]="minDate1" [max]="maxDate1" [formControl]="date2" [matDatepicker]="picker1" (dateInput)="addEvent('input', $event,'date1_end')">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="row ml-1 mr-1 mt-1">
          <div class="example-action-buttons">
            <button mat-button (click)="set_filter('reset')">Reset Filters</button>
          </div>
        </div>
        
        <div class="row ml-1 mr-1 mt-1">
          <div class="example-action-buttons">
            <button mat-button (click)="accordion.openAll()">Expand All</button>
            <button mat-button (click)="accordion.closeAll()">Collapse All</button>
          </div>
        </div>

        <div class="row mt-1">
          <mat-accordion class="example-headers-align" multi>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Group
                </mat-panel-title>
              </mat-expansion-panel-header>
          
              <section class="checkbox-section">
                <span class="checkbox-list-section">
                  <mat-checkbox class="checkbox-margin"
                                [checked]="allSelected_Group"
                                [indeterminate]="someSelected_Group()"
                                (change)="setAll_Group($event.checked)">
                    Select ALL
                  </mat-checkbox>
                </span>
                <span class="checkbox-list-section">
                  <ul>
                    <li *ngFor="let filter of group.filters">
                      <mat-checkbox [(ngModel)]="filter.selected"
                                    (ngModelChange)="updateAllSelected_Group()">
                        {{filter.name}}
                      </mat-checkbox>
                    </li>
                  </ul>
                </span>
                <button class="btn_set_filter" mat-button (click)="set_filter('group')">Set Filter</button>
              </section>

            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Alert Type
                </mat-panel-title>
              </mat-expansion-panel-header>
          
              <section class="checkbox-section">
                <span class="checkbox-list-section">
                  <mat-checkbox class="checkbox-margin"
                                [checked]="allSelected_Alert"
                                [indeterminate]="someSelected_Alert()"
                                (change)="setAll_Alert($event.checked)">
                    Select ALL
                  </mat-checkbox>
                </span>
                <span class="checkbox-list-section">
                  <ul>
                    <li *ngFor="let filter of alert.filters">
                      <mat-checkbox [(ngModel)]="filter.selected"
                                    (ngModelChange)="updateAllSelected_Alert()">
                        {{filter.name}}
                      </mat-checkbox>
                    </li>
                  </ul>
                </span>
                <button class="btn_set_filter" mat-button (click)="set_filter('alert')">Set Filter</button>
              </section>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Edge Location
                </mat-panel-title>
              </mat-expansion-panel-header>
          
              <section class="checkbox-section">
                <span class="checkbox-list-section">
                  <mat-checkbox class="checkbox-margin"
                                [checked]="allSelected_Edge_loc"
                                [indeterminate]="someSelected_Edge_loc()"
                                (change)="setAll_Edge_loc($event.checked)">
                    Select ALL
                  </mat-checkbox>
                </span>
                <span class="checkbox-list-section">
                  <ul>
                    <li *ngFor="let filter of edge_loc.filters">
                      <mat-checkbox [(ngModel)]="filter.selected"
                                    (ngModelChange)="updateAllSelected_Edge_loc()">
                        {{filter.name}}
                      </mat-checkbox>
                    </li>
                  </ul>
                </span>
                <button class="btn_set_filter" mat-button (click)="set_filter('edge_loc')">Set Filter</button>
              </section>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Edge Device
                </mat-panel-title>
              </mat-expansion-panel-header>
          
              <section class="checkbox-section">
                <span class="checkbox-list-section">
                  <mat-checkbox class="checkbox-margin"
                                [checked]="allSelected_Device"
                                [indeterminate]="someSelected_Device()"
                                (change)="setAll_Device($event.checked)">
                    Select ALL
                  </mat-checkbox>
                </span>
                <span class="checkbox-list-section">
                  <ul>
                    <li *ngFor="let filter of device.filters">
                      <mat-checkbox [(ngModel)]="filter.selected"
                                    (ngModelChange)="updateAllSelected_Device()">
                        {{filter.name}}
                      </mat-checkbox>
                    </li>
                  </ul>
                </span>
                <button class="btn_set_filter" mat-button (click)="set_filter('device')">Set Filter</button>
              </section>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Camera Name
                </mat-panel-title>
              </mat-expansion-panel-header>
          
              <section class="checkbox-section">
                <span class="checkbox-list-section">
                  <mat-checkbox class="checkbox-margin"
                                [checked]="allSelected_Cam_name"
                                [indeterminate]="someSelected_Cam_name()"
                                (change)="setAll_Cam_name($event.checked)">
                    Select ALL
                  </mat-checkbox>
                </span>
                <span class="checkbox-list-section">
                  <ul>
                    <li *ngFor="let filter of cam_name.filters">
                      <mat-checkbox [(ngModel)]="filter.selected"
                                    (ngModelChange)="updateAllSelected_Cam_name()">
                        {{filter.name}}
                      </mat-checkbox>
                    </li>
                  </ul>
                </span>
                <button class="btn_set_filter" mat-button (click)="set_filter('cam_name')">Set Filter</button>
              </section>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Camera Location
                </mat-panel-title>
              </mat-expansion-panel-header>
          
              <section class="checkbox-section">
                <span class="checkbox-list-section">
                  <mat-checkbox class="checkbox-margin"
                                [checked]="allSelected_Cam_loc"
                                [indeterminate]="someSelected_Cam_loc()"
                                (change)="setAll_Cam_loc($event.checked)">
                    Select ALL
                  </mat-checkbox>
                </span>
                <span class="checkbox-list-section">
                  <ul>
                    <li *ngFor="let filter of cam_loc.filters">
                      <mat-checkbox [(ngModel)]="filter.selected"
                                    (ngModelChange)="updateAllSelected_Cam_loc()">
                        {{filter.name}}
                      </mat-checkbox>
                    </li>
                  </ul>
                </span>
                <button class="btn_set_filter" mat-button (click)="set_filter('cam_loc')">Set Filter</button>
              </section>
            </mat-expansion-panel>

          </mat-accordion>
        </div>


     

      </div>

    </mat-drawer>
  
    <div class="example-sidenav-content">

      <div class="container">

        <div class="row progress" *ngIf="query_in_progress">
          <mat-progress-bar mode="query"></mat-progress-bar>
        </div>

        <div class="row info-cards" *ngIf="cards_data">
          <ngx-charts-number-card
            [scheme]="colorScheme"
            [results]="cards_data"
            [cardColor]="cardColor">
          </ngx-charts-number-card>
        </div>

        <div class="row progress" *ngIf="query_in_progress">
          <mat-progress-bar mode="query"></mat-progress-bar>
        </div>
        <div class="row line-chart" *ngIf="chart_1_data">
          <ngx-charts-line-chart
            [scheme]="colorScheme"
            [legend]="legend"
            [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel"
            [xAxis]="xAxis"
            [yAxis]="yAxis"
            [xAxisLabel]="xAxisLabel"
            [yAxisLabel]="yAxisLabel"
            [timeline]="timeline"
            [results]="chart_1_data"
            >
          </ngx-charts-line-chart>
        </div>

        <div class="row progress" *ngIf="query_in_progress">
          <mat-progress-bar mode="query"></mat-progress-bar>
        </div>
        <div class="row mat-elevation-z8 data-table" *ngIf="table_1_data">
          <span class="table-name">Camera wise Violations</span>
          <table mat-table [dataSource]="table_1_data" matSort>

            <!-- Position Column -->
            <ng-container matColumnDef="group">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Group </th>
              <td mat-cell *matCellDef="let element"> {{element._id.group}} </td>
            </ng-container>
          
            <!-- Name Column -->
            <ng-container matColumnDef="location">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Location </th>
              <td mat-cell *matCellDef="let element"> {{element._id.location}} </td>
            </ng-container>
          
            <!-- Weight Column -->
            <ng-container matColumnDef="serialno">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Serial No </th>
              <td mat-cell *matCellDef="let element"> {{element._id.serialno}} </td>
            </ng-container>
          
            <!-- Symbol Column -->
            <ng-container matColumnDef="camera">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Camera Name </th>
              <td mat-cell *matCellDef="let element"> {{element._id.cam_name}} </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="count">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Count </th>
              <td mat-cell *matCellDef="let element"> {{element.count}} </td>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>

      </div>
       

    </div>
  
</mat-drawer-container>
  